import { Route } from '@angular/router';
import { authGuard } from '../../guards/auth.guard';

export const ShopRoutes: Route[] = [
  {
    path: 'shop',
    loadComponent: () => import('../layout/shop/shop.layout'),
    canActivateChild: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        data: { title: '쇼핑몰 대시보드' },
        loadComponent: () =>
          import('../pages/shop/shop-dashboard/shop-dashboard.page'),
      },
      {
        path: 'product',
        data: { title: '상품 관리' },
        loadComponent: () =>
          import('../pages/shop/shop-product/shop-product.page'),
      },
      {
        path: 'product/new',
        data: { title: '상품 등록' },
        loadComponent: () =>
          import('../pages/shop/shop-product-form/shop-product-form.page'),
      },
      {
        path: 'product/:id',
        data: { title: '상품 상세' },
        loadComponent: () =>
          import('../pages/shop/shop-product-detail/shop-product-detail.page'),
      },
      {
        path: 'product/:id/edit',
        data: { title: '상품 수정' },
        loadComponent: () =>
          import('../pages/shop/shop-product-form/shop-product-form.page'),
      },
      {
        path: 'payment',
        data: { title: '결제 관리' },
        loadComponent: () =>
          import('../pages/shop/shop-payment/shop-payment.page'),
      },
    ],
  },
];
